var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({visibility: (_vm.visible ? 'inherit' : 'hidden')}),on:{"click":function($event){$event.stopPropagation();return _vm.stop.apply(null, arguments)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }